import de from './translations/de.json';

// English is the default message in each of our source files,
// so no need for a separate en.json file
const en = {};

// If we add more than just german, just import the files and
// export it below: export default { en, de, es }
export default { en, de };
